<template>
  <span
    class="shiny-text"
    :class="{ 'shiny-text--animated': !disabled }"
    :style="{ animationDuration: speed + 's' }"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script>
export default {
  name: 'ShinyText',
  props: {
    text: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    speed: { type: Number, default: 5 }
  }
}
</script>

<style scoped>
.shiny-text {
  color: rgba(255, 255, 255, 0.65);
  background-image: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0) 60%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  display: inline-block;
}

.shiny-text--animated {
  animation: shiny-slide linear infinite;
}

@keyframes shiny-slide {
  0% { background-position: 100%; }
  100% { background-position: -100%; }
}
</style>
